import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { RxTemplate } from '@shared/rx-templates/rx-template.model';
import { ProcedureMap } from '@shared/models/procedure-map';
import { ISectionDirtyCheckService } from '@shared/models/section-dirty-check';
import { OrderQuery } from './state/order-query';

/** v1 flow: a selected procedure type is lost when the target procedure map has no type (null, 0 or negative). */
@Injectable({ providedIn: 'root' })
export class ProcedureTypeV1DirtyCheckService implements ISectionDirtyCheckService {
	constructor(private readonly orderQuery: OrderQuery) {}

	willLoseDataFor$(_targetTemplate: Readonly<RxTemplate>, targetProcedureMap: ProcedureMap | null): Observable<boolean> {
		const targetTypeId = targetProcedureMap?.TypeId;
		const targetHasNoType = targetTypeId == null || targetTypeId <= 0;

		return of(targetHasNoType && this.orderQuery.hasProcedureTypeId);
	}
}
